import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

const TABS = {
  buyer: ["notes", "tips", "transaction"],
  seller: ["notes", "tips", "readiness"],
};

const JourneyWorkspaceContext = createContext(null);

export function JourneyWorkspaceProvider({ mode, children }) {
  const [params, setParams] = useSearchParams();
  const allowed = TABS[mode] || TABS.buyer;
  const fromUrl = params.get("panel");
  const [tab, setTabState] = useState(() => (allowed.includes(fromUrl) ? fromUrl : "notes"));

  useEffect(() => {
    if (allowed.includes(fromUrl) && fromUrl !== tab) {
      setTabState(fromUrl);
    }
  }, [allowed, fromUrl, tab]);

  const setTab = useCallback(
    (next) => {
      if (!allowed.includes(next)) return;
      setTabState(next);
      const nextParams = new URLSearchParams(params);
      nextParams.set("panel", next);
      setParams(nextParams, { replace: true });
    },
    [allowed, params, setParams]
  );

  const value = useMemo(() => ({ mode, tab, setTab, tabs: allowed }), [mode, tab, setTab, allowed]);

  return <JourneyWorkspaceContext.Provider value={value}>{children}</JourneyWorkspaceContext.Provider>;
}

export function useJourneyWorkspace() {
  const context = useContext(JourneyWorkspaceContext);
  if (!context) {
    throw new Error("useJourneyWorkspace must be used within JourneyWorkspaceProvider");
  }
  return context;
}
